import { AnimatePresence, motion } from 'framer-motion';
import { AddNodeMenu } from '@chatsdet/ui';

export type FlowDesignerEdgeMenuProps = {
  selectedEdgeId: string | null;
  edgeMenuPosition: { x: number; y: number } | null;
  hasApiCatalog: boolean;
  hasSandboxActions: boolean;
  hasMcp: boolean;
  clearEdgeSelection: () => void;
  handleInsertNodeOnEdge: (nodeType: string) => void;
  handleDeleteSelectedEdge: () => void;
};

const baseVisibleTypes = [
  'login',
  'navigate',
  'action',
  'assertion',
  'condition',
  'wait',
  'call_flow',
  'notification',
  'audio',
  'audio-assertion',
  'visual_checkpoint',
];

function visibleEdgeInsertTypes(hasApiCatalog: boolean, hasSandboxActions: boolean, hasMcp: boolean) {
  return [
    ...baseVisibleTypes.slice(0, 6),
    ...(hasApiCatalog ? ['api_sequence'] : []),
    ...(hasSandboxActions ? ['sandbox_action'] : []),
    ...(hasMcp ? ['mcp'] : []),
    ...baseVisibleTypes.slice(6),
  ];
}

export function FlowDesignerEdgeMenu({
  selectedEdgeId,
  edgeMenuPosition,
  hasApiCatalog,
  hasSandboxActions,
  hasMcp,
  clearEdgeSelection,
  handleInsertNodeOnEdge,
  handleDeleteSelectedEdge,
}: FlowDesignerEdgeMenuProps) {
  return (
    <AnimatePresence>
      {selectedEdgeId && edgeMenuPosition && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40"
            onClick={clearEdgeSelection}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.1 }}
            className="fixed z-50"
            style={{ left: edgeMenuPosition.x, top: edgeMenuPosition.y }}
          >
            <AddNodeMenu
              header="Insert step"
              visibleTypes={visibleEdgeInsertTypes(hasApiCatalog, hasSandboxActions, hasMcp)}
              onSelect={(type) => handleInsertNodeOnEdge(type)}
              footerActions={[
                {
                  label: 'Delete connection',
                  onClick: handleDeleteSelectedEdge,
                  destructive: true,
                },
              ]}
            />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
